<template>
  <div>
    <div class="ui container">
      <h2 class="ui dividing header">
        <img src="/images/icons/account_summary.png" />
        <div class="content">
          {{ $t("account summary") }}
        </div>
      </h2>
    </div>
    <generic-container
      style="margin-top:20px"
      :title="$t('movements')"
      icon="exchange"
      ref="movements_container"
    >
      <!-- <pre>{{account}}</pre> -->
      <table
        class="ui very compact selectable celled striped table"
        ref="movement_table"
        style="width:100%"
      >
        <thead>
          <tr>
            <th>{{ $t("type") }}</th>
            <th>{{ $t("date") }}</th>
            <th>{{ $t("amount") }}</th>
            <th>{{ $t("status") }}</th>
          </tr>
        </thead>
        <tbody></tbody>
      </table>
    </generic-container>
    <generic-container
      style="margin-top:20px"
      :title="$t('transactions')"
      icon="exchange"
      ref="transactions_container"
    >
      <!-- <pre>{{account}}</pre> -->
      <table
        class="ui very compact selectable celled striped table"
        ref="transaction_table"
        style="width:100%"
      >
        <thead>
          <tr>
            <th>{{ $t("type") }}</th>
            <th>{{ $t("date") }}</th>
            <th>{{ $t("amount") }}</th>
          </tr>
        </thead>
        <tbody></tbody>
      </table>
    </generic-container>
  </div>
</template>

<script>
import filters from "@/filters";
import GenericContainer from "@/components/GenericContainer";
import { local_api, stringify, init_json_local_data_datables } from "@/utils";

// @ is an alias to /src
export default {
  name: "StudentPortalAccountIndex",
  components: {
    "generic-container": GenericContainer,
  },
  filters: filters,
  data() {
    return {
      movements: [],
      transactions: [],
    };
  },
  methods: {},
  created() {},
  mounted() {
    let vm = this;
    let portalUser = vm.$session.get("portal_user");
    let studentUuid = portalUser.student_id;
    local_api(vm, "post", "/student_portal/account/do-get", {
      u: studentUuid,
    })
      .then((account) => {
        vm.account = account;

        if (
          account &&
          account.std_account_movements &&
          account.std_account_movements.length
        ) {
          /*vm.account.std_account_movements*/ let movements = vm.account.std_account_movements.map(
            (t) => {
              t.std_account_movement_type.setup = JSON.parse(
                t.std_account_movement_type.setup,
              );
              return t;
            },
          );

          let columns = [
            {
              data: function(row) {
                return row.std_account_movement_type.name;
              },
            },
            {
              data: function(row) {
                return row.create_date;
                // return filters.formatDate(
                //   row.create_date,
                //   vm.$session.get("enterprise_setup").detailed_date_format,
                // );
              },
            },
            {
              data: function(row) {
                return filters.formatCurrency(row.amount);
              },
            },
            {
              data: function(row) {
                if (
                  row.std_account_movement_type &&
                  row.std_account_movement_type.setup
                ) {
                  return `<div class="ui indicating progress" style="margin-bottom:0" data-value="${row.paid}" data-total="${row.amount}">
  <div class="bar">
    <div class="progress"></div>
  </div>
</div>`;
                } else {
                  return "¿?";
                }
              },
            },
          ];

          let updateProgress = () => {
            setTimeout(() => {
              window.jQuery(".ui.progress").progress();
            }, 200);
          };

          init_json_local_data_datables(
            vm,
            vm.$refs.movement_table,
            movements,
            columns,
            null,
            () => {
              updateProgress();
            },
            () => {
              updateProgress();
            },
          );
        }

        if (
          account &&
          account.acc_transactions &&
          account.acc_transactions.length
        ) {
          /*vm.account.acc_transactions*/ let transactions = vm.account.acc_transactions.map(
            (t) => {
              t.acc_transaction_type.setup = JSON.parse(
                t.acc_transaction_type.setup,
              );
              return t;
            },
          );

          let columns = [
            {
              data: function(row) {
                return row.acc_transaction_type.name;
              },
            },
            {
              data: function(row) {
                return row.create_date;
                // return filters.formatDate(
                //   row.create_date,
                //   vm.$session.get("enterprise_setup")
                //     .detailed_date_format,
                // );
              },
            },
            {
              data: function(row) {
                return filters.formatCurrency(row.amount);
              },
            },
          ];

          init_json_local_data_datables(
            vm,
            vm.$refs.transaction_table,
            transactions,
            columns,
            null,
            null,
            null,
          );
        }
      })
      .catch((err) => {
        console.log(err);
        vm.$alertify.error(stringify(err));
      });
  },
  watch: {},
};
</script>
